<template>
  <div data-testid="titleHeader" class="a-title-header">
    <div class="a-title-header__heading-part">
      <div v-if="heading" class="a-title-header__heading--main">
        <h1 class="a-title-header__heading">
          {{ heading }}
        </h1>
        <p v-if="subhead" class="a-title-header__subhead">
          {{ subhead }}
        </p>
      </div>
      <div v-if="hasDetails" class="a-title-header__heading--details">
        <slot name="details"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitleHeader",
  props: {
    /**
     * The heading string
     */
    heading: {
      type: String,
      required: false,
      default: undefined
    },
    /**
     * The subhead string
     */
    subhead: {
      type: String,
      required: false,
      default: undefined
    },
    /**
     * The subhead string
     */
    hasDetails: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
